"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateWatchDataProvider = exports.getItemSkuDetailsHandler = exports.getWatchListHandler = void 0;
exports.addToWatchHandler = addToWatchHandler;
exports.removeFromWatchHandler = removeFromWatchHandler;
const watch_1 = require("../../services/watch");
const storage_handler_1 = require("./storage-handler");
const constants_1 = require("../../constants");
const { ADD_ACTION, REMOVE_ACTION } = constants_1.WATCH_ACTION;
function handleWatchListChange(action, settings, itemDetails, listDetail, trackingData) {
    (0, storage_handler_1.setSessionData)(constants_1.SESSION_STORAGE, itemDetails, action, trackingData);
    const isAddOperation = action === ADD_ACTION;
    const csrfToken = isAddOperation
        ? settings.addToWatchCSRFToken
        : settings.removeFromWatchCSRFToken;
    const data = Object.assign(Object.assign(Object.assign({}, itemDetails), listDetail), { hostname: settings.hostname, csrfToken,
        trackingData });
    const response = isAddOperation ? (0, watch_1.addToWatch)(data) : (0, watch_1.removeFromWatch)(data);
    return response;
}
const getWatchListHandler = (settings) => (0, watch_1.getWatchList)(settings);
exports.getWatchListHandler = getWatchListHandler;
const getItemSkuDetailsHandler = (settings, itemId) => (0, watch_1.getItemVariation)(settings, itemId);
exports.getItemSkuDetailsHandler = getItemSkuDetailsHandler;
function addToWatchHandler(settings, itemDetails, listDetail, trackingData) {
    return handleWatchListChange(ADD_ACTION, settings, itemDetails, listDetail, trackingData);
}
function removeFromWatchHandler(settings, itemDetails, listDetail, trackingData) {
    return handleWatchListChange(REMOVE_ACTION, settings, itemDetails, listDetail, trackingData);
}
const validateWatchDataProvider = (watchDataProvider, shouldGetWatchList, shouldGetItemSkuDetails) => {
    let errorMessage = '';
    if (!watchDataProvider) {
        errorMessage = 'Watch data provider is not available';
        console.error(errorMessage);
        return new Error(errorMessage);
    }
    if (!watchDataProvider.apiSettings ||
        !watchDataProvider.apiSettings.addToWatchCSRFToken ||
        !watchDataProvider.apiSettings.hostname) {
        errorMessage = 'Watch API settings are not available';
        console.error(errorMessage);
        return new Error(errorMessage);
    }
    if (shouldGetWatchList && !watchDataProvider.getWatchListHandler) {
        errorMessage = 'Watch list handler is not available';
        console.error(errorMessage);
        return new Error(errorMessage);
    }
    if (shouldGetItemSkuDetails &&
        !watchDataProvider.getItemSkuDetailsHandler) {
        errorMessage = 'Item SKU details handler is not available';
        console.error(errorMessage);
        return new Error(errorMessage);
    }
    if (!watchDataProvider.addToWatchHandler) {
        errorMessage = 'Add to watch handler is not available';
        console.error(errorMessage);
        return new Error(errorMessage);
    }
    if (!watchDataProvider.removeFromWatchHandler) {
        errorMessage = 'Remove from watch handler is not available';
        console.error(errorMessage);
        return new Error(errorMessage);
    }
};
exports.validateWatchDataProvider = validateWatchDataProvider;
